import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	dialog: {
		...shorthands.borderRadius(tokens.borderRadiusMedium),
		maxWidth: "630px",
		width: "auto",
	},
	dialogSmall: {
		maxWidth: "340px",
	},
	dialogLarge: {
		maxWidth: "1000px",
	},
});

export const useConfirmationDialogStyle = makeStyles({
	buttonsContainer: {
		paddingTop: "20px",
	},
});
